<div class="cardBloque ">
    <div class="row">
        <div class="col-md-2">

        </div>
        <div class="col-md-8">
            <div class="card">
                <form #f="ngForm">
                    <div class="card-header">
                        <!-- <h1 class="text-center">Buscador</h1> -->
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary" type="button" data-toggle="collapse"
                                    data-target="#collapsableSearch" aria-expanded="false"
                                    aria-controls="collapsableSearch">
                                    Buscador
                                </button>
                            </div>
                        </div>
                        <div class="row mt-3 collapse" id="collapsableSearch">


                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Tipo de propiedad</label>
                                    <select class="custom-select" #typeProperty name="typeProperty" id="typeProperty"
                                        ngModel>
                                        <option [value]="null" [selected]="true">Todos </option>
                                        <option *ngFor="let x of typesProperty" [value]="x.name">{{x.name}} </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Tipo de operacion</label>
                                    <select class="custom-select" #type_operation name="type_operation"
                                        id="type_operation" ngModel>
                                        <option value="null" [selected]>Cualquiera </option>
                                        <option value="Venta" [selected]>Venta </option>
                                        <option value="Renta" [selected]>Renta </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Precio Minimo</label>
                                    <input class="form-control" #prices_min name="prices_min" id="prices_min" ngModel>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Precio Maximo</label>
                                    <input class="form-control" #prices_max name="prices_max" id="prices_max" ngModel>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary" type="button" data-toggle="collapse"
                                    data-target="#collapsableProvince" aria-expanded="false"
                                    aria-controls="collapsableProvince">
                                    Ver Municipios
                                </button>
                            </div>
                            <div class="col-md-12 collapse" id="collapsableProvince">
                                <div class="form-group">
                                    <label for="">Municipio</label>
                                    <select class="custom-select" #province name="province" id="province" ngModel>
                                        <option value="todos" [selected]>Todos </option>
                                        <option *ngFor="let x of provinces" [value]="x.name" [selected]>{{x.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 mt-3 text-center">
                                <button class="btn btn-primary" (click)="buscar(f.value)">Buscar</button>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="card-footer text-center">
                    </div> -->
                </form>
            </div>
        </div>
    </div>
    <!-- Este es el codigo de dacita -->
    <div class="row">
        <div class=" col-md-6 col-lg-4 col-xl-4  col-12" *ngIf="esSLP === true">
            <div class="card">
                <img class="img-responsiva  img-fluid  " style="height: 250px;" src="{{ proyecto?.Images[0]?.uri }}"
                    alt="Card image cap" />
                <div class="card-body">
                    <h2>{{ proyecto?.name }}</h2>
                    <span style="font-size: 18px;">Venta</span>
                    <br>
                    <span style="font-size: 22px;"> $1,340,000 - $1,540,000 MXN.</span>
                    <p class="card-text ">
                        San Luis Potosí, San Luis Potosí
                    </p>
                    <div class=" d-flex justify-content-center">
                        <a type="button" class="btn btn-primary" rippleEffect
                            href="https://dacita.4sales.mx/p/torredacita" target="_blank">
                            <span [data-feather]="'home'" [class]="'mr-25'"></span>Ver propiedad</a>
                    </div>
                </div>
            </div>
        </div>
        <div class=" col-md-6 col-lg-4 col-xl-4  col-12" *ngFor="let propiedad of properties.data">
            <div class="card" *ngIf="propiedad != undefined">
                <img class="img-responsiva  img-fluid  " style="height: 250px;" src="{{ propiedad?.images[0]?.s3Url }}"
                    alt="Card image cap" />
                <div class="card-body">
                    <h2>{{ propiedad?.announcement_title }}</h2>
                    <span style="font-size: 18px;">{{ propiedad?.prices[0]?.property_operation?.name }}</span>
                    <br>
                    <span style="font-size: 22px;">{{ propiedad?.prices[0]?.amount | currency: 'USD' : 'symbol' :
                        '1.0-0' }}
                        {{
                        propiedad?.prices[0]?.currency?.name }}</span>
                    <p class="card-text ">
                        {{ propiedad?.location?.state }}, {{ propiedad?.location.municipality }}
                    </p>
                    <div class=" d-flex justify-content-center">
                        <button type="button" class="btn btn-primary" rippleEffect
                            (click)="viewProperty(propiedad?.id)">
                            <span [data-feather]="'home'" [class]="'mr-25'"></span>Ver propiedad</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
            <div class="d-flex justify-content-between float-right m-1">
                <ngb-pagination [collectionSize]="properties.last_page * 9" [maxSize]="9" [rotate]="true"
                    [(page)]="page" [pageSize]="9" (pageChange)="onPageChange();" aria-label="Cambiar página">
                    <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                            [class]="'font-weight-bolder text-primary'"></span>
                    </ng-template>
                    <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                            [class]="'font-weight-bolder text-primary'"></span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </div>
    </div>